import './index.css';
import Hero from '../../components/Hero';
import Footer from '../../components/Footer';

const sectionDesc = 'Documentos diposibles sobre doctrina y fundamentos de la Iglesia';

export default function Documentos(){
    return(
        <main className="g-main documents">
            <Hero title="Documentos" description={sectionDesc} size="s" />
            <section className="content-main">
                documentos
            </section>
            <Footer />
        </main>
    );
}